async function onCreatePasskeyClicked() {
  addNetworkSimulation("GET /auth/challenge");

  const requireUserVerificationCheckboxElement = document.getElementById("requireUserVerification")
  if (!requireUserVerificationCheckboxElement || !(requireUserVerificationCheckboxElement instanceof HTMLInputElement)) {
    throw new Error("Could not find requireUserVerificationCheckboxElement")
  }
  const requireUserVerification = requireUserVerificationCheckboxElement.checked;


  const userNameInputElement = document.getElementById("usernameInput")
  if (!userNameInputElement || !(userNameInputElement instanceof HTMLInputElement)) {
    throw new Error("Could not find userNameInputElement")
  }
  const userName = userNameInputElement.value;

  let publicKeyCreationOptions: PublicKeyCredentialCreationOptions = {
    challenge: crypto.getRandomValues(new Uint8Array(32)),
    rp: {
      name: "Demo App",
      id: window.location.hostname,
    },
    user: {
      id: crypto.getRandomValues(new Uint8Array(16)),
      name: userName,
      displayName: userName,
    },
    pubKeyCredParams: [
      { type: "public-key", alg: -7 }, // ES256, Elliptic Curve
      { type: "public-key", alg: -257 }, // RS256, Classic RSA
    ],
    authenticatorSelection: {
      residentKey: "required",
      requireResidentKey: true,
      // Bypassing user verification doesn't work in some cases, probably enforced by the browser/OS for some security reason
      userVerification: requireUserVerification ? "required" : "discouraged",
    },
    timeout: 60000,
    attestation: "none",
  };
  addNetworkSimulation("    200 OK (challenge received)");

  let credential;
  try {
    credential = await navigator.credentials.create({
      publicKey: publicKeyCreationOptions,
    });
    if (!credential) {
      setResult("Credential creation was cancelled or failed.");
      return;
    }
  } catch (err) {
    console.error("Error creating credential:", err);
    setResult("Error creating credential: " + err);
    return;
  }

  addNetworkSimulation("POST /auth/register (sending credential)");
  // Here you would normally send the credential to the server for verification and storage
  setPasskeyStored(credential);
  addNetworkSimulation("    201 Created (credential registered)");
  setResult(
    "Passkey successfully created and stored on server (simulated).",
  );
}

async function onLoginClicked() {
  addNetworkSimulation("GET /auth/challenge");

  const requireUserVerificationCheckbox = document.getElementById("requireUserVerification")
  if (!requireUserVerificationCheckbox || !(requireUserVerificationCheckbox instanceof HTMLInputElement)) {
    throw new Error("Could not find requireUserVerificationCheckbox")
  }
  const requireUserVerification = requireUserVerificationCheckbox.checked;

  const allowCredentials: PublicKeyCredentialDescriptor[] = [];
  if (window.passkeyId) {
    allowCredentials.push({
      type: "public-key",
      id: window.passkeyId as unknown as BufferSource, // Works, typings are less permissive
    });
  }

  let publicKeyRequestOptions: PublicKeyCredentialRequestOptions = {
    challenge: crypto.getRandomValues(new Uint8Array(32)),
    timeout: 60000,
    rpId: window.location.hostname,
    allowCredentials,
    userVerification: requireUserVerification ? "required" : "discouraged",
  };
  addNetworkSimulation("    200 OK (challenge received)");

  let assertion;
  try {
    assertion = await navigator.credentials.get({
      publicKey: publicKeyRequestOptions,
    });
    if (!assertion) {
      setResult("Assertion was cancelled or failed.");
      return;
    }
  } catch (err) {
    setResult("Error getting assertion: " + err);
    return;
  }

  addNetworkSimulation("POST /auth/login (sending assertion)");
  // Here you would normally verify the assertion on the server side
  setPasskeyStored(assertion);
  addNetworkSimulation("    200 OK (login successful)");
  setResult("Login successful using stored passkey!");
}

function addNetworkSimulation(label: string) {
  const networkElement = document.getElementById("network");
  if (!networkElement) {
    throw new Error("Could not find networkElement")
  }
  networkElement.textContent += label + "\n";
}

function setResult(label: string) {
  const resultElement = document.getElementById("result");
  if (!resultElement) {
    throw new Error("Could not find resultElement")
  }
  resultElement.innerHTML = label;
}

function setPasskeyStored(passkey: Credential) {
  const hasPasskeyStoredElement = document.getElementById("hasPasskeyStored");
  if (!hasPasskeyStoredElement) {
    throw new Error("Could not find hasPasskeyStoredElement")
  }
  hasPasskeyStoredElement.textContent =
    "YES (It will not be persisted after a reload) (Do not forget to cleanup your passkeys after testing)";
  window.passkeyId = passkey.id;
}

const createPasskeyButton = document.getElementById("createPasskeyButton");
if (!createPasskeyButton) {
  throw new Error("Could not find createPasskeyButton")
}
createPasskeyButton.addEventListener("click", onCreatePasskeyClicked);

const loginButton = document.getElementById("loginButton");
if (!loginButton) {
  throw new Error("Could not find loginButton")
}
loginButton.addEventListener("click", onLoginClicked);

declare global {
  interface Window { passkeyId: string; }
}

export { };
